<template>
  <div>
    <iframe
      allow="camera; microphone"
      @load="resizeIframe"
      ref="tradein"
      id="trade-in"
      frameBorder="0"
      class="iframe"
      :style="{ width: '100%', height: '100vh' }"
      :src="link"
    />

    <div class="mt-2">
      <a :href="link" target="_blank">
        {{ "if_not_show" | setText("У меня не открывает экран") }}</a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "products",
  created() {
    this.$loading(true);
  },
  methods: {
    resizeIframe() {
      this.$loading(false);
    },
    copyLogin() {
      const textArea = document.createElement("textarea");
      textArea.value = this.login;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      textArea.remove();
      this.$notify({
        title: `Скопировано ${this.login}`,
        message: "Логин скопирован",
        icon: "ti-save",
        horizontalAlign: "right",
        verticalAlign: "top",
      });
    },
    copyPassword() {
      const textArea = document.createElement("textarea");
      textArea.value = this.password;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      textArea.remove();
      this.$notify({
        title: `Скопировано ${this.password}`,
        message: "Пароль скопирован",
        icon: "ti-save",
        horizontalAlign: "right",
        verticalAlign: "top",
      });
    },
  },
  computed: {
    login() {
      return this.$store.state.user["email"];
    },
    password() {
      return this.$store.state.user["code"];
    },
    link: {
      get() {
        return `https://app.buyback.cloud/login?username=${this.$store.state.user.phone.replace(
          "+",
          ""
        )}_${this.$store.state.shop ? this.$store.state.shop.id : ""}&code=${
          this.$store.state.user.code
        }`;
      },
      set(val) {},
    },
  },
};
</script>
<style>
</style>
